module.exports = __webpack_public_path__ + "static/media/323.e4dbc19b.svg";